import type { LayerState } from '@/types';
import { db, type AppDatabase } from './db';

/**
 * Adds layer states whose `layerId` is not stored yet and returns every stored row.
 * The check and the insert share one transaction, so overlapping layer-list builds
 * (a remount, an account reset, a second tab) cannot store the same layer twice.
 */
export async function storeLayerStates(layerStates: readonly Omit<LayerState, 'id'>[], database: AppDatabase = db): Promise<LayerState[]> {
    return database.transaction('rw', database.layerState, async () => {
        const stored = new Set((await database.layerState.toArray()).map((layer) => layer.layerId));
        const missing = layerStates.filter((layer) => {
            if (stored.has(layer.layerId)) return false;
            stored.add(layer.layerId);
            return true;
        });
        if (missing.length > 0) await database.layerState.bulkAdd(missing as LayerState[]);
        return database.layerState.toArray();
    });
}
